import { QuoteInfoTable } from 'routes/essential-workspace/components/quote-panel/quote/info-table';
import { QuotePriceText } from 'routes/essential-workspace/components/quote-panel/quote/price-text';

export function QuotePricedDetails() {
  return (
    <div className="flex-y py-0 gap-2 text-center quote-details-min-height">
      <div id="quote-price" className="quote-pricing-container py-3">
        <QuotePriceText className="quote-price" />
      </div>
      <QuoteInfoTable />
    </div>
  );
}
